<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title>FILTRI</v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col md="3" sm="5" xs="12">
                                <v-menu
                                    v-model="menu"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="dataIni"
                                            label="Inizio"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        @change="
                                            getMontanti(dataIni, selectedShop)
                                        "
                                        v-model="dataIni"
                                        type="month"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col md="3" sm="5" xs="12">
                                <div>
                                    <v-select
                                        :items="arrShops"
                                        v-model="selectedShop"
                                        label="Negozi"
                                        @change="
                                            getMontanti(dataIni, selectedShop)
                                        "
                                        item-text="description"
                                        item-value="id"
                                    >
                                    </v-select>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col>
                <v-simple-table dense>
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th
                                    colspan="5"
                                    class="text-center header-background"
                                >
                                    Giornaliero
                                </th>
                                <th
                                    colspan="3"
                                    class="text-center header-background"
                                >
                                    Mensile
                                </th>
                                <th
                                    colspan="3"
                                    class="text-center header-background"
                                >
                                    Annuale
                                </th>
                            </tr>
                            <tr>
                                <th
                                    colspan="2"
                                    class="text-center col-background-celeste"
                                >
                                    Anno in corso
                                </th>
                                <th
                                    colspan="2"
                                    class="text-center col-background-yellow"
                                >
                                    Scorso anno
                                </th>
                                <th class="text-center col-background-grey">
                                    Delta %
                                </th>
                                <th class="text-center col-background-celeste">
                                    Anno in corso
                                </th>
                                <th class="text-center col-background-yellow">
                                    Scorso anno
                                </th>
                                <th class="text-center col-background-grey">
                                    Delta %
                                </th>
                                <th class="text-center col-background-celeste">
                                    Anno in corso
                                </th>
                                <th class="text-center col-background-yellow">
                                    Scorso anno
                                </th>
                                <th class="text-center col-background-grey">
                                    Delta %
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in montanti" :key="index">
                                <td class="col-background-celeste">
                                    <span v-if="item.current_incasso">
                                        {{ item.current_date }}
                                    </span>
                                </td>
                                <td class="col-background-grey">
                                    <span v-if="item.current_incasso">
                                        {{ item.current_incasso | formatEuro }}
                                    </span>
                                </td>
                                <td class="col-background-yellow">
                                    <span v-if="item.past_incasso">
                                        {{ item.past_date }}
                                    </span>
                                </td>
                                <td class="col-background-grey">
                                    {{ item.past_incasso | formatEuro }}
                                </td>
                                <td>
                                    <span
                                        v-if="item.current_incasso"
                                        :class="percClass(item.delta)"
                                    >
                                        {{ item.delta | percRound }} %
                                    </span>
                                </td>
                                <td class="col-background-grey">
                                    <span v-if="item.current_incasso">
                                        {{
                                            item.current_incasso_monthly
                                                | formatEuro
                                        }}
                                    </span>
                                </td>
                                <td class="col-background-grey">
                                    {{ item.past_incasso_monthly | formatEuro }}
                                </td>
                                <td>
                                    <span
                                        v-if="item.current_incasso"
                                        :class="percClass(item.delta_monthly)"
                                    >
                                        {{ item.delta_monthly | percRound }} %
                                    </span>
                                </td>
                                <td class="col-background-grey">
                                    <span v-if="item.current_incasso">
                                        {{
                                            item.current_incasso_yearly
                                                | formatEuro
                                        }}
                                    </span>
                                </td>
                                <td class="col-background-grey">
                                    {{ item.past_incasso_yearly | formatEuro }}
                                </td>
                                <td>
                                    <span
                                        v-if="item.current_incasso"
                                        :class="percClass(item.delta_yearly)"
                                    >
                                        {{ item.delta_yearly | percRound }} %
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-col>
        </v-row>
    </v-container>
</template>
<style scoped lang="scss">
.v-data-table::v-deep > .v-data-table__wrapper > table {
    border-spacing: 2px;

    th,
    td {
        border: 1px solid black;
        font-weight: bold;
    }
}

.header-background {
    background-color: #ffdaa3;
}

.col-background-celeste {
    background-color: #e6fefe;
}

.col-background-yellow {
    background-color: #ffffcd;
}

.col-background-grey {
    background-color: #fafcfb;
}

.text-color-red {
    color: red;
}

.text-color-green {
    color: green;
}
</style>
<script>
import requests from "../../requests";
import DialogIncassiVue from "./DialogIncassi.vue";
export default {
    name: "montanti-page",
    components: {
        DialogIncassiVue,
    },

    data: () => {
        return {
            menu: false,
            dataIni: null,
            loading: false,
            montanti: [],
            dialog: false,
            arrShops: [],
            selectedShop: 0,
            editIncasso: {},
            panel: 0,
            totali: {},
        };
    },
    mounted() {
        console.log("Montanti Mounted.");
        this.dataIni = this.$moment().startOf("month").format("YYYY-MM");
        this.loading = true;
        console.log(window.currentUser);
        this.getShopList();
    },
    methods: {
        onCloseDialog() {
            this.dialog = false;
        },
        getShopList() {
            requests.getShopList().then((res) => {
                if (window.currentUser.role == "Admin") {
                    this.arrShops = [{
                        description: "TUTTI",
                        id: "tutti",
                    }, ...res.data];
                } else this.arrShops = res.data;
                this.selectedShop = this.arrShops[0].id;
                this.getMontanti(this.dataIni, this.selectedShop);
            });
        },
        getMontanti(dIni, shopId) {
            requests.getMontanti(dIni, shopId).then((res) => {
                this.montanti = res.data;
                this.loading = false;
            });
        },

        percClass(num) {
            if (parseFloat(num) > 0) {
                return "text-color-green";
            } else if (parseFloat(num) < 0) {
                return "text-color-red";
            }
            return "";
        },
    },

    filters: {
        formatEuro(number) {
            if (_.isNaN(number)) return 0;
            return new Intl.NumberFormat("it-IT", {
                style: "currency",
                currency: "EUR",
            }).format(number);
        },
        percRound(number) {
            if (_.isNaN(number)) return "-";
            return Math.round(number * 100) / 100;
        },
    },
};
</script>
